export const normalizedKeys = [
    "carryDistance",
    "totalDistance",
    "side",
    "sideTotal",
    "apex"
]